import { render, staticRenderFns } from "./BranchRoleManagement.vue?vue&type=template&id=6021f575"
import script from "./BranchRoleManagement.vue?vue&type=script&lang=js"
export * from "./BranchRoleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports